<template>
 <div>
    <div id="overlay"  v-if="loading">
      <div class="spinner"></div>
      <br/>
        <h4>Loading...</h4>
    </div>
      <form >
        <div class="p-grid">
          <div class="p-col">
            <Button class="p-button p-component p-button-success addNewBtn width-auto"  @click.prevent="openBasic" icon="pi pi-plus" label="NEW" />
          </div>
        </div>
        <Dialogs header="Income Account"  :visible.sync="displayBasic"
           :style="{width: '50vw'}" :modal="true" :closable=false :contentStyle="{'overflow': 'visible'}">
            <div class="p-fluid p-formgrid p-grid">
             <div class="p-field p-col-12 p-md-6">
                <label for="name">Name<span style="color:red">*</span></label>
                <InputText  type="text" class="col-sm-5 form-control _input" id="name" v-model.trim="accountName"/>
             </div>
             <div class="p-field p-col-12 p-md-6">
                <label for="shortName">Short Name</label>
                <InputText v-model.trim="shortName" id="shortName"/>
             </div>
             <div class="p-field p-col-12 p-md-6">
                <label for="head">Group<span style="color:red">*</span></label>
                <Dropdown
                v-model="accountHead"
                :options="accountHeadLists"
                optionLabel="name"
                :filter="true"
                placeholder="Select Group"
                @change="selectDrCrType(accountHead.id)"
                :showClear="true"/>
             </div>
              <accountgroupdialog style="margin-top:1.3em"  v-tooltip.top="'Add Account Group'" @set_data="set_data"/>
              <div class="p-field p-col-12 p-md-6">
                <label for="subHead">Sub Group</label>
                <Dropdown
                v-model="accountSubHead"
                :options="accountSubGroupLists"
                optionLabel="name"
                :filter="true"
                placeholder="Select Sub Group"
                :showClear="true"/>
              </div>
              <accountsubgroupdialog style="margin-top:1.3em" @set_data_subhead="set_data_subhead"/>
              <div class="p-field p-col-12 p-md-6">
                <label for="openingBalance">Opening Balance</label>
                <InputText @keypress="isNumber($event)" v-model.number="openingBalance"/>
              </div>
              <div class="p-field p-col-12 p-md-6">
                <label for="accountType">Dr/Cr Type</label>
                <select class="form-control" v-model="openingDrCr">
                  <option selected disabled value="">Select Dr/Cr</option>
                  <option  v-for="(drcr,ind) in dr_crList" :key="ind">{{drcr.openingDrCr}}</option>
                </select>
              </div>
              <div class="p-field p-col-12 p-md-6">
                <label for="openingBalance">Status</label>
                 <div class="p-field p-col-12 p-md-6">
                 <RadioButton id="city1" name="ACTIVE" value="ACTIVE" v-model="status" />
                  <label for="city1">Active</label>
                  <RadioButton id="city1" name="INACTIVE" value="INACTIVE" v-model="status" />
                  <label for="city1">Inactive</label>
                </div>
              </div>
            </div>
        <template #footer>
          <Button class="p-button-raised" @click.prevent="addAccountMaster" :label="editing?'Update':'Add'"/>
           <Button class="p-button-raised p-button-info" @click.prevent="saveAndNewAccountMaster" v-if="!editing" label="Add & New"/>
          <Button @click.prevent="cancel" class="p-button-raised p-button-danger" label="Cancel"/>
        </template>
        </Dialogs>
      </form>
 </div>
</template>
<script>
import Dropdown from 'primevue/dropdown'
import RadioButton from 'primevue/radiobutton'
import Dialogs from 'primevue/dialog'
import accountgroupdialog from './AccountGroupDialog.vue'
import accountsubgroupdialog from './AccountSubGroupDialog.vue'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
export default {
  name: 'incomeaccountdialog',
  data() {
    return {
      accountName: '',
      accountSubHead: '',
      accountHead: '',
      shortName: '',
      openingBalance: '',
      status: 'ACTIVE',
      drCr: '',
      openingDrCr: 'Cr',
      dr_crList: [
        {'openingDrCr': 'Dr'},
        {'openingDrCr': 'Cr'}
      ],
      displayBasic: false,
      editing: false,
      id: null,
      loading: false,
      accountSubGroupLists: [],
      reaccountSubGroupLists: []
    }
  },
  computed: {
    accountHeadLists() {
      return this.$store.state.accountHead.accountHeadDropListByNature
    },
    accountSubHeadLists() {
      return this.$store.state.accountHead.accountSubHeadDropList
    },
    incomeMasterLists() {
      return this.$store.state.accountMaster.incomeAccountLists
    }
  },
  mounted() {
    this.accountSubHeadList()
    this.accountHeadList()
    // this.selectDrCrType()
  },
  methods: {
    async addAccountMaster() {
      let resp = ''
      if (this.accountName === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Account name cannot be empty!', life: 10000})
        return
      }
      if (this.accountHead === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select account group!', life: 10000})
        return
      }
      if (this.accountSubHead === undefined) {
        this.accountSubHead == null
        this.accountSubHeadId = 0
      } else {
        this.accountSubHeadId = this.accountSubHead.id
      }
      let accountMaster = {
        name: this.accountName,
        shortName: this.shortName,
        accountSubHeadId: this.accountSubHeadId,
        accountHeadId: this.accountHead.id,
        openingBalance: this.openingBalance,
        openingDrCr: this.openingDrCr,
        id: this.id,
        status: this.status
      }
      if (!this.editing) {
        this.loading = !this.loading
        resp = await this.$store.dispatch('createIncomeAccount', accountMaster)
        this.loading = false
      } else {
        this.loading = !this.loading
        resp = await this.$store.dispatch('updateIncomeAccount', accountMaster)
        this.loading = false
      }
      this.responseValue(resp)
      this.closeBasic()
    },
    async saveAndNewAccountMaster() {
      let response = ''
      if (this.accountName === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Account name cannot be empty!', life: 10000})
        return
      }
      if (this.accountHead === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select account group!', life: 10000})
        return
      }
      if (this.accountSubHead === undefined) {
        this.accountSubHead == null
        this.accountSubHeadId = 0
      } else {
        this.accountSubHeadId = this.accountSubHead.id
      }
      let accountMaster = {
        name: this.accountName,
        shortName: this.shortName,
        accountSubHeadId: this.accountSubHeadId,
        accountHeadId: this.accountHead.id,
        openingBalance: this.openingBalance,
        openingDrCr: this.openingDrCr,
        status: this.status
      }
      this.loading = !this.loading
      response = await this.$store.dispatch('createAccountMaster', accountMaster)
      this.loading = false
      this.responseValue(response)
    },
    responseValue(response) {
      if (response.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 10000})
        this.closeBasic()
        this.reset()
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: response.data.message, life: 10000})
      }
    },
    set_data(data) {
      this.accountHead = data
      this.selectDrCrType(data.id)
    },
    set_data_subhead(data) {
      this.accountSubHead = data
      this.selectDrCrType(data.id)
    },
    async accountSubHeadList() {
      let resp = await this.$store.dispatch('accountSubHeadDropDownByNature', 4)
      this.accountSubGroupLists = resp.data.data
      this.reaccountSubGroupLists = resp.data.data
    },
    async accountHeadList() {
      await this.$store.dispatch('accountHeadDropDownByNature', 4)
    },
    async incomeMasterList() {
      await this.$store.dispatch('loadIncomeAccountList')
    },
    updateIncomeAccount(data) {
      this.editing = !this.editing
      this.displayBasic = !this.displayBasic
      this.accountName = data.name
      this.shortName = data.shortName
      this.accountSubHead = data.accountSubHead
      this.openingBalance = data.openingBalance
      this.accountHead = data.accountHead
      this.status = data.status
      if (data.openingBalance === 0) {
        this.openingDrCr = 'Dr'
      } else {
        this.openingDrCr = data.drCr
      }
      this.status = data.status
      this.id = data.id
    },
    selectDrCrType(id) {
      let filteredSubGroup = 0
      if (this.accountSubGroupLists.length === 0 || filteredSubGroup === 0) {
        this.accountSubGroupLists = this.reaccountSubGroupLists
      }
      if (!this.editing) {
        if (this.accountHead.natureName === 'Assets' || this.accountHead.natureName === 'Expenses') {
          this.openingDrCr = 'Dr'
        } else if (this.accountHead.natureName === 'Liabilities' || this.accountHead.natureName === 'Incomes') {
          this.openingDrCr = 'Cr'
        }
      }
      filteredSubGroup = this.accountSubGroupLists.filter(subHead => subHead.headId === id)
      this.accountSubGroupLists = filteredSubGroup
    },
    cancel(data) {
      this.reset()
      this.closeBasic()
    },
    reset() {
      this.accountSubHead = ''
      this.accountHead = ''
      this.accountName = ''
      this.shortName = ''
      this.openingBalance = ''
      this.openingDrCr = 'Cr'
      this.editing = false
      this.accountSubGroupLists = this.reaccountSubGroupLists
      // this.closeBasic()
    },
    isNumber(evt) {
      evt = window.event
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    openBasic() {
      this.displayBasic = true
    },
    closeBasic() {
      this.displayBasic = false
    }
  },
  components: {
    Dropdown,
    RadioButton,
    Dialogs,
    accountgroupdialog,
    accountsubgroupdialog,
    InputText,
    Button
  }
}
</script>
<style scoped src="@../../../static/css/dialogEntry.css">

</style>



// WEBPACK FOOTER //
// IncomeAccountDialog.vue?26a8078e